import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { InteractionType, KeyValueSet, LocalService, PageKey } from 'src/service/local.service';

@Component({
  selector: 'app-receipt-templates',
  templateUrl: './receipt-templates.component.html',
  styleUrl: './receipt-templates.component.scss'
})
export class ReceiptTemplatesComponent {
  lstSectionConfigKeys: string[] = ["table", "printer"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; businessId: string;

  maxBodyHeight = 0; tabs: KeyValueSet[] = []; selectedTab: string = '1';

  constructor(public localService: LocalService, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.configurationManagementService.ensurePageActions(PageKey.ReceiptTemplates);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.businessId = routeParams.businessId;
      this.onInitiate();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(40);
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoadTabs();
  }

  onLoadTabs() {
    this.tabs = [{
      key: '1',
      value: "Receipt Templates"
    } as KeyValueSet,
    {
      key: '2',
      value: "Template - Printer Mapping"
    } as KeyValueSet];
  }

  onLoad() {

  }
}
